










import Vue from 'vue';
import Component from 'vue-class-component';
import { State } from 'vuex-class';

import ErrorPage from '@/components/global/ErrorPage/ErrorPage.vue';

import _ from 'lodash';

@Component({
	components: {
		ErrorPage
	}
})
export default class Erreur401Expire extends Vue {
	get messageErreur() {
		return 'Vous devez vous reconnecter via le <a href="https://espacepro.ameli.fr/">portail amelipro</a> ou via <a href="https://vaccination-covid.ameli.fr/">Pro Santé Connect</a>';
	}

}
